<template>
  <div id="manage-login" class="manage-login">
    <div v-if="mode === manageLoginModes.VERIFY_EMAIL">
      <h2 v-if="emailIsVerified">Email Verified</h2>
      <h2 v-else>Verify Email</h2>
      <div v-if="emailIsVerified">
        <p>Thank you for verifying your email.</p>
        <p>You can now <router-link :to="{name: 'login'}">login</router-link> to Click &lsquo;em Quick.</p>
      </div>
      <div v-else>
        <p v-if="firebaseErrorMessage">{{ firebaseErrorMessage }}</p>
      </div>
    </div>
    <div v-else-if="mode === manageLoginModes.RESET_PASSWORD">
      <h2>Reset Password</h2>
      <p v-if="firebaseErrorMessage">{{ firebaseErrorMessage }}</p>
    </div>
    <div v-else-if="mode === manageLoginModes.RECOVER_EMAIL">
      <h2>Recover Email</h2>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app';
import db from './../firebaseInit';
import {MANAGE_LOGIN_MODES, NOTIFICATION_SETTINGS} from './../constants/globalConstants';

export default {
  name: 'manage-login',
  title: 'Manage Login',
  data: function() {
    return {
      apiKey: '',
      lang: '',
      mode: '',
      oobCode: '',
      emailIsVerified: false,
      firebaseErrorMessage: '',
      manageLoginModes: MANAGE_LOGIN_MODES,
    };
  },
  created() {
    this.apiKey = this.$route.query.apiKey;
    this.lang = this.$route.query.lang;
    this.mode = this.$route.query.mode;
    this.oobCode = this.$route.query.oobCode;
    if (this.oobCode) {
      firebase
        .auth()
        .applyActionCode(this.oobCode)
        .then(resp => {
          if (this.mode === this.manageLoginModes.VERIFY_EMAIL) {
            this.emailIsVerified = true;
            this.$store.dispatch('userVuexModule/SET_EMAIL_VERIFIED_ACTION');
          } else if (this.mode === this.manageLoginModes.RESET_PASSWORD) {
            // console.log('RESET_PASSWORD');
          } else if (this.mode === this.manageLoginModes.RECOVER_EMAIL) {
            // console.log('RECOVER_EMAIL');
          }
        })
        .catch(err => {
          this.$snotify.error('Error applying ActionCode', '', NOTIFICATION_SETTINGS);
          this.firebaseErrorMessage = err.message;
        });
    }
  },
  methods: {},
};
</script>

<style lang="scss" scoped></style>
